<script setup>
import DetailPanelJob from './DetailPanelJob.vue';
import DetailPanelPet from './DetailPanelPet.vue';
import DetailPanelDictionary from './DetailPanelDictionary.vue';

import { useAnalysisDataStore } from '@/store/modules/analysisDataStore';

const analysisDataStore = useAnalysisDataStore();
const props = defineProps({
  selectedDescNav: {
    type: String,
    default: 'personalityJob',
  },
  guestUserId: {
    type: Number,
    default: 0,
  },
  showOnlyDictionary: {
    type: Boolean,
    default: false,
  },
});
const emit = defineEmits(['update:selectedDescNav']);

function updateNav(value) {
  emit('update:selectedDescNav', value);
}

const personalityTabMap = {
  personalityJob: DetailPanelJob,
  personalityPet: DetailPanelPet,
  personalityDictionary: DetailPanelDictionary,
};
const SelectedPersonalityTab = computed(() => personalityTabMap[props.selectedDescNav]);

// showOnlyDictionary일 때 용어해석 탭 자동 선택
onMounted(() => {
  if (props.showOnlyDictionary && props.selectedDescNav !== 'personalityDictionary') {
    updateNav('personalityDictionary');
  }
});
</script>

<template>
  <div class="desc-header">
    <div class="desc-nav">
      <button
        v-if="!showOnlyDictionary"
        :class="['nav-button', { active: selectedDescNav === 'personalityJob' }]"
        @click="updateNav('personalityJob')"
      >
        직업추천
      </button>
      <button
        v-if="!showOnlyDictionary"
        :class="['nav-button', { active: selectedDescNav === 'personalityPet' }]"
        @click="updateNav('personalityPet')"
      >
        반려친구
      </button>
      <button
        :class="['nav-button', { active: selectedDescNav === 'personalityDictionary' }]"
        @click="updateNav('personalityDictionary')"
      >
        용어해석
      </button>
    </div>

    <i class="bot-button"></i>
  </div>

  <div v-if="SelectedPersonalityTab" class="desc-container w-100">
    <div class="inner">
      <div class="main-card">
        <component :is="SelectedPersonalityTab" :guestUserId="guestUserId" />
      </div>
    </div>
  </div>
</template>
